<script setup lang="ts">
import { CupraButton } from '@/components/cupra/button'
import { CupraHeading } from '@/components/cupra/heading'
import LocationsMap from '@/components/LocationsMap.vue'
import { Location, MapOptions } from '@/models'
import { ref } from 'vue'

const emit = defineEmits(['back', 'submit'])

defineProps<{
    mapOptions: MapOptions
    locations: Array<Location>
    submitLabel?: string
}>()

const selectedLocation = ref<Location>()
</script>

<template>
    <div class="mt-1.5 mb-3">
        <slot />
    </div>
    <div class="flex flex-col gap-4 md:flex-row">
        <LocationsMap
            v-if="mapOptions && locations"
            :options="mapOptions"
            :locations="locations"
            class="h-100 w-full flex-none md:w-2/3"
            @select-location="(l) => (selectedLocation = l)"
        />
        <div
            v-if="!!selectedLocation"
            class="flex flex-col"
        >
            <CupraHeading
                as="h3"
                :variant="3"
                >Gekozen locatie</CupraHeading
            >
            <p class="mt-3 font-bold">{{ selectedLocation.name }}</p>
            <p>
                {{ selectedLocation.address }}<br />
                {{ selectedLocation.postal_code }} {{ selectedLocation.city }}
            </p>
        </div>
    </div>
    <div class="mt-6 grid gap-2 sm:grid-cols-2">
        <CupraButton
            @click="emit('submit', selectedLocation)"
            :disabled="!selectedLocation"
            >{{ submitLabel || 'Kies locatie' }}</CupraButton
        >
        <CupraButton
            variant="secondary"
            @click="emit('back')"
            direction="back"
            class="sm:order-first"
            >Terug</CupraButton
        >
    </div>
    <div
        v-if="$slots.footer"
        class="text-cupra-grey mt-4 text-sm"
    >
        <slot name="footer"></slot>
    </div>
</template>
